/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FilterRow } from './FilterRow';
import {
    FilterRowFromJSON,
    FilterRowFromJSONTyped,
    FilterRowToJSON,
} from './FilterRow';
import type { FilterRowOperatorConstants } from './FilterRowOperatorConstants';
import {
    FilterRowOperatorConstantsFromJSON,
    FilterRowOperatorConstantsFromJSONTyped,
    FilterRowOperatorConstantsToJSON,
} from './FilterRowOperatorConstants';

/**
 * Root node of the filter expression tree
 * @export
 * @interface FilterNode
 */
export interface FilterNode {
    /**
     * 
     * @type {FilterRow}
     * @memberof FilterNode
     */
    filterRow?: FilterRow;
    /**
     * 
     * @type {FilterRowOperatorConstants}
     * @memberof FilterNode
     */
    filterRowOperator?: FilterRowOperatorConstants;
    /**
     * 
     * @type {FilterNode}
     * @memberof FilterNode
     */
    left?: FilterNode;
    /**
     * 
     * @type {FilterNode}
     * @memberof FilterNode
     */
    right?: FilterNode;
    /**
     * Whether or not this node is a leaf
     * @type {boolean}
     * @memberof FilterNode
     */
    leaf: boolean;
}

/**
 * Check if a given object implements the FilterNode interface.
 */
export function instanceOfFilterNode(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "leaf" in value;

    return isInstance;
}

export function FilterNodeFromJSON(json: any): FilterNode {
    return FilterNodeFromJSONTyped(json, false);
}

export function FilterNodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterNode {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'filterRow': !exists(json, 'filterRow') ? undefined : FilterRowFromJSON(json['filterRow']),
        'filterRowOperator': !exists(json, 'filterRowOperator') ? undefined : FilterRowOperatorConstantsFromJSON(json['filterRowOperator']),
        'left': !exists(json, 'left') ? undefined : FilterNodeFromJSON(json['left']),
        'right': !exists(json, 'right') ? undefined : FilterNodeFromJSON(json['right']),
        'leaf': json['leaf'],
    };
}

export function FilterNodeToJSON(value?: FilterNode | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'filterRow': FilterRowToJSON(value.filterRow),
        'filterRowOperator': FilterRowOperatorConstantsToJSON(value.filterRowOperator),
        'left': FilterNodeToJSON(value.left),
        'right': FilterNodeToJSON(value.right),
        'leaf': value.leaf,
    };
}

